export enum MessageAuthorType {
  User = 'user',
  AI = 'ai',
  System = 'system'
}

export enum MessageType {
  DirectMessage = 'direct-message',
  ChannelMessage = 'channel-message',
  User = 'user',
  AI = 'ai',
  System = 'system',
  Message = 'message',
  FunctionCall = 'function_call',
  Planning = 'planning'
}
